<template>
  <div>
    <Hero heading="My Past Projects" bg="bg_tech-computer.jpg" />
    <transition name="fade" appear>
      <div class="container">
        <div class="plugins-wrapper">
          <div class="plugin" v-bind:key="index" v-for="(project, index) in projects">
            <h3 class="h-text-icon">
              <span>{{project.name}}</span>
              <a v-if="project.url" :href="project.url" target="_blank">
                <LinkIcon />
              </a>
            </h3>
            <div class="project-wrapper">
              <div class="project">
                <p>{{ project.description }}</p>
                <div class="project__media" v-if="project.media">
                  <figure v-bind:key="index" v-for="(media, index) in project.media">
                    <img
                      v-img:group
                      :src="media.src"
                      :alt="media.caption"
                      style="max-width: 200px;"
                    />
                    <figcaption>{{ media.caption }}</figcaption>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Hero from '../Hero';
import LinkIcon from '../../assets/svg/link.svg';

export default {
  name: 'Projects',
  data() {
    return {
      projects: [
        {
          name: 'Elliot eCommerce',
          description:
            'Frontend development for the admin dashboard app in React, React Hook, Context API, UIKit, TypeScript, and GraphQL.',
          media: [
            {
              src: require('../../assets/projects/elliot/dashboard.png'),
              caption: 'Dashboard',
            },
            {
              src: require('../../assets/projects/elliot/wallet.png'),
              caption: 'Wallet',
            },
            {
              src: require('../../assets/projects/elliot/wallet-add-card.png'),
              caption: 'Wallet Add Card',
            },
            {
              src: require('../../assets/projects/elliot/order-details.png'),
              caption: 'Order Details',
            },
          ],
          url: 'https://admin.elliot.store/'
        },
        {
          name: 'TimelineIO',
          description:
            'Full-stack development for enabling asynchronous feedback workflow in React, jQuery, Rails, REST API, and MySQL.',
          media: [
            {
              src: require('../../assets/projects/timeline-feedback-web.png'),
              caption: 'Visual Feedback Web',
            },
            {
              src: require('../../assets/projects/timeline-feedback-graphic.png'),
              caption: 'Visual Feedback Graphic',
            },
            {
              src: require('../../assets/projects/timeline-event-timeline.png'),
              caption: 'Events Timeline View',
            },
            {
              src: require('../../assets/projects/timeline-event-filebrowser.png'),
              caption: 'Events File Browser View',
            },
          ],
          url: 'https://www.timeline.io/'
        },
        {
          name: 'PubPeer',
          description:
            'Full-stack development for improving the existing system and adding new features in Vue.js, Bootstrap, Laravel, ElasticSearch, MariaDB.',
          media: [
            {
              src: require('../../assets/projects/pubpeer-search.png'),
              caption: 'Publication Search',
            },
            {
              src: require('../../assets/projects/pubpeer-publication.png'),
              caption: 'Publication Detail',
            },
            {
              src: require('../../assets/projects/pubpeer-extensions.png'),
              caption: 'Extensions View',
            },
          ],
          url: 'https://pubpeer.com/'
        },
        {
          name: 'ExpressVPN',
          description:
            'Browser extension development for controlling cross-platform desktop applications on major browsers in Vue.js.\nQA automation tool development for testing the extension products in multiple browsers/OSs in Node.js, Selenium, Cucumber, Java, Maven, Appium.',
          media: [
            {
              src: require('../../assets/projects/expressvpn-connected.png'),
              caption: 'VPN Connected',
            },
            {
              src: require('../../assets/projects/expressvpn-locations.png'),
              caption: 'VPN Locations',
            },
            {
              src: require('../../assets/projects/expressvpn-settings.png'),
              caption: 'VPN Setting',
            },
          ],
          url: 'https://www.expressvpn.com/vpn-software/chrome-vpn'
        },
        {
          name: 'Browser Extensions/AddOns',
          description:
            'Built lots of browser extensions that get a specific set of data from the social network and eCommerce platforms and do some functions by interacting with the service API on those platforms.',
          media: [
            {
              src: require('../../assets/projects/alicoupon.jpg'),
              caption: 'AliExpress Coupon Finder',
            },
            {
              src: require('../../assets/projects/express.jpg'),
              caption: 'VPN Proxy Extension',
            },
          ],
        },
      ],
    };
  },
  components: {
    Hero,
    LinkIcon,
    // GithubIcon,
    // jQueryIcon,
    // ShareIcon,
  },
};
</script>

<style scoped>
.project {
  a {
    text-decoration: none;
  }

  p {
    margin: 0;
  }
}

.project__media {
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap;
  margin: 20px 0;
  padding: 10px;
  background-color: #ececec;

  figure {
    margin: 15px;
    align-self: center;
    flex: 0;
  }
}

@media (max-width: 767px) {
  .project__media {
    justify-content: center;
  }
}

.project__heading {
  margin-bottom: 10px;
}

.project__links {
  display: flex;
  margin-top: 20px;

  > *:not(:last-child) {
    margin-right: 25px;
  }
}

.project__source {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #636363;
  transition: color 0.3s ease-in-out;

  > *:not(:last-child) {
    margin-right: 8px;
  }

  &:hover {
    color: #1a1a1a;
  }
}

.plugins-wrapper {
  > *:not(:last-child) {
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px dashed #ccc;
  }
}

.project-wrapper {
  > *:not(:last-child) {
    margin-bottom: 15px;
    padding-bottom: 15px;
  }
}
</style>
